<template>
  <div class="comp-status-tag" v-if="props.status">
    <jw-tag :color="colorMap[props.status]">{{ statusNameMap[props.status] }}</jw-tag>
  </div>
</template>

<script setup>
import { TaskStatusEnum } from '@/components/migration-detail/constant';
const props = defineProps({
  status: {
    type: String,
    default: ''
  }
});
const colorMap = {
  [TaskStatusEnum.NEW]: 'gray',
  [TaskStatusEnum.DOING]: 'blue',
  [TaskStatusEnum.DONE]: 'green',
  [TaskStatusEnum.ERROR]: 'red'
};
const statusNameMap = {
  [TaskStatusEnum.NEW]: '未处理',
  [TaskStatusEnum.DOING]: '进行中',
  [TaskStatusEnum.DONE]: '已完成',
  [TaskStatusEnum.ERROR]: '失败'
};
</script>
<style scoped lang="less">
@import './status-tag.less';
</style>
